// extracted by mini-css-extract-plugin
export default {"Item_Pesquisa":"estilo_Item_Pesquisa__eILkD"};